// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGGhost = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#ghost__clip0_12_2737)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "ghost__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#ghost__clip1_12_2737)",
        children: /*#__PURE__*/_jsx("g", {
          clipPath: "url(#ghost__clip2_12_2737)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M1.429 26.572c.628 0 1.142.514 1.142 1.143v1.143c0 .628.515 1.142 1.143 1.142h1.143C5.486 30 6 30.515 6 31.143c0 .629-.514 1.143-1.143 1.143H3.714c-1.885 0-3.428-1.543-3.428-3.428v-1.143c0-.629.514-1.143 1.143-1.143zM14 30c.629 0 1.143.515 1.143 1.143 0 .629-.514 1.143-1.143 1.143H9.429c-.629 0-1.143-.514-1.143-1.143 0-.628.514-1.143 1.143-1.143H14zM23.143 30c.628 0 1.143.515 1.143 1.143 0 .629-.515 1.143-1.143 1.143H18.57c-.628 0-1.142-.514-1.142-1.143 0-.628.514-1.143 1.142-1.143h4.572zM31.143 26.572c.628 0 1.143.514 1.143 1.143v1.143c0 1.885-1.543 3.428-3.429 3.428h-1.143c-.628 0-1.143-.514-1.143-1.143 0-.628.515-1.143 1.143-1.143h1.143c.629 0 1.143-.514 1.143-1.142v-1.143c0-.629.514-1.143 1.143-1.143zM1.429 17.429c.628 0 1.142.514 1.142 1.143v4.571c0 .629-.514 1.143-1.142 1.143-.629 0-1.143-.514-1.143-1.143v-4.571c0-.629.514-1.143 1.143-1.143zM31.143 17.429c.628 0 1.143.514 1.143 1.143v4.571c0 .629-.515 1.143-1.143 1.143-.629 0-1.143-.514-1.143-1.143v-4.571c0-.629.514-1.143 1.143-1.143zM16.366 17.44c2.32 0 4.491.938 6.103 2.64.434.458.411 1.178-.046 1.612-.216.205-.5.306-.783.307-.296-.001-.602-.114-.829-.352-1.177-1.246-2.765-1.932-4.445-1.932-1.68 0-3.27.686-4.446 1.932-.435.456-1.155.48-1.612.045-.457-.434-.48-1.154-.046-1.611 1.623-1.703 3.784-2.64 6.104-2.64zM21.646 22h-.012.012zM1.429 8.286c.628 0 1.142.514 1.142 1.143V14c0 .629-.514 1.143-1.142 1.143C.8 15.143.286 14.63.286 14V9.43c0-.629.514-1.143 1.143-1.143zM11.806 10.572c1.262 0 2.286 1.023 2.286 2.286 0 1.262-1.024 2.285-2.286 2.285-1.263 0-2.286-1.023-2.286-2.285 0-1.263 1.023-2.286 2.286-2.286zM20.949 10.572c1.262 0 2.285 1.023 2.285 2.286 0 1.262-1.023 2.285-2.285 2.285-1.263 0-2.286-1.023-2.286-2.285 0-1.263 1.023-2.286 2.286-2.286zM31.143 8.286c.628 0 1.143.514 1.143 1.143V14c0 .629-.515 1.143-1.143 1.143C30.514 15.143 30 14.63 30 14V9.43c0-.629.514-1.143 1.143-1.143zM4.857.286C5.486.286 6 .8 6 1.43s-.514 1.143-1.143 1.143H3.714c-.628 0-1.143.514-1.143 1.143v1.143C2.571 5.486 2.057 6 1.43 6 .8 6 .286 5.486.286 4.858V3.715C.286 1.829 1.829.286 3.714.286h1.143zM28.857.286c1.886 0 3.429 1.543 3.429 3.429v1.143c0 .628-.515 1.142-1.143 1.142C30.514 6 30 5.486 30 4.858V3.715c0-.629-.514-1.143-1.143-1.143h-1.143c-.628 0-1.143-.514-1.143-1.143S27.086.286 27.714.286h1.143zM14 .286c.629 0 1.143.514 1.143 1.143S14.629 2.572 14 2.572H9.429c-.629 0-1.143-.514-1.143-1.143S8.8.286 9.429.286H14zM23.143.286c.628 0 1.143.514 1.143 1.143s-.515 1.143-1.143 1.143H18.57c-.628 0-1.142-.514-1.142-1.143S17.943.286 18.57.286h4.572z"
          })
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#ghost__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "ghost__clip0_12_2737",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "ghost__clip1_12_2737",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "ghost__clip2_12_2737",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGGhost.displayName = 'SVGGhost';
export default SVGGhost;